import { render } from "./brackets.vue?vue&type=template&id=67875e2c"
import script from "./brackets.vue?vue&type=script&lang=js"
export * from "./brackets.vue?vue&type=script&lang=js"

import "./brackets.vue?vue&type=style&index=0&id=67875e2c&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__